import { Injectable } from '@angular/core';
import { Dossier, FitterServiceType } from '@sc/data-access-models';
import { DossierManagerService } from '@sc/feature-fitter-shared-libs';
import { BehaviorSubject, Observable } from 'rxjs';
import { PlanningCalendarService } from './planning-calendar.service';

@Injectable({
  providedIn: 'root',
})
export class PlanningFormSandboxService {
  private readonly serviceTypeSelection$ =
    new BehaviorSubject<FitterServiceType>(null);

  constructor(
    private readonly planningCalendarService: PlanningCalendarService,
    private readonly dossierManagerService: DossierManagerService
  ) {}

  selectNewServiceType(newServiceType: FitterServiceType) {
    this.serviceTypeSelection$.next(newServiceType);
  }

  newServiceTypeSelections(): Observable<FitterServiceType> {
    return this.serviceTypeSelection$;
  }

  isReadonlyDossier(dossier: Dossier, forceEdit = false) {
    // Dossiers can be editable in all cases except if :
    // - the dossier is abandonned
    // - the appointment is done
    // - the appointment is cancelled or no-show and not forced to edit (through the resume button for example)
    // - the appointment is being edited by another user
    return (
      this.planningCalendarService.isDossierAbandoned(dossier) ||
      this.planningCalendarService.isAppointmentDone(dossier) ||
      ((this.planningCalendarService.isDossierCancelled(dossier) ||
        this.planningCalendarService.isDossierNoShow(dossier)) &&
        !forceEdit) ||
      this.dossierManagerService.dossierOpennedBySomeoneElse(dossier)
    );
  }
}
